"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconStacks4 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var IconStackCenter_1 = require("../../bricks/IconStackCenter");
// similar to IconStacks8, svg icons instead of number circles
var IconStacks4 = function (_a) {
    var cards = _a.cards;
    return ((0, jsx_runtime_1.jsx)("section", { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "row g-0 text-center fw-light border-grid" }, { children: cards.map(function (item, index) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "col-sm-6 col-lg-3 border border-primary" }, { children: (0, jsx_runtime_1.jsx)(IconStackCenter_1.IconStackCenter, { Icon: item.Icon, heading: item.heading, paragraph: item.paragraph }) }), index)); }) })) }));
};
exports.IconStacks4 = IconStacks4;
